export default __webpack_public_path__ + "static/media/logo.4f686f31.png";